import {
    FETCH_REQUEST, FetchRequestAction
} from '../../../middleware';
import { getConfigGatewayUrl } from '../../state';
import { transformAppInit } from '../../state/effects-middleware/utils/app-fetch-configuration';
import { FETCH_NOTIFICATIONS } from './notifications.reducer';
import { NotificationsData } from './notifications.types';

export const fetchNotifications = (): FetchRequestAction<NotificationsData> => ({
    type: FETCH_REQUEST,
    payload: {
        name: FETCH_NOTIFICATIONS,
        resolveUrl: getConfigGatewayUrl({
            key: 'UserPortalGateway',
            basePath: '/api/v1/notifications'
        }),
        body: null,
        method: 'GET',
        transformInit: transformAppInit
    }
});

